import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<UseMutationOptions<unknown, Error, {}>, 'mutationKey' | 'mutationFn'>;
}

export const useDeletePromptRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, {}>(
    [Entities.Prompts, 'delete'],
    async () => {
      const { data } = await api.v1AdminPromptsPromptIdDelete(id)
      return data
    },
    { ...options }
  )
}
